import { OAuthStorage } from 'angular-oauth2-oidc';

/**
 * Inizializzazione del LocalStorage per l'autenticazione
 * Rif. https://manfredsteyer.github.io/angular-oauth2-oidc/docs/additional-documentation/configure-custom-oauthstorage.html
 *
 * @returns {OAuthStorage}
 */
export function oAuthStorageFactory(): OAuthStorage {
  return localStorage;
}
